import { ApiCallState } from "../Utils";

export type Store = {
  company(company: any): unknown;
  id: number;
  name: string;
  wereda: string;
  city: string;
  type: string;
  project_id?: number;
  createdAt: string;
  materialCount?: number;
};

export type StoreStateTypes = {
  fetchAll: ApiCallState<Store[]>;
  fetchOne: ApiCallState<Store | {}>;
};

export const StoreActionTypes = {
  FETCH_ALL_STORE: "FETCH_ALL_STORE",
  FETCH_ALL_STORE_RESET: "FETCH_ALL_STORE_RESET",
  FETCH_ALL_STORE_FAILURE: "FETCH_ALL_STORE_FAILURE",
  FETCH_ALL_STORE_SUCCESS: "FETCH_ALL_STORE_SUCCESS",

  FETCH_ONE_STORE: "FETCH_ONE_STORE",
  FETCH_ONE_STORE_RESET: "FETCH_ONE_STORE_RESET",
  FETCH_ONE_STORE_FAILURE: "FETCH_ONE_STORE_FAILURE",
  FETCH_ONE_STORE_SUCCESS: "FETCH_ONE_STORE_SUCCESS",
};
